import { useState, useEffect, useRef, createRef, useContext, Fragment } from "react"
import {
    ArrowPathRoundedSquareIcon, XCircleIcon,
    CloudArrowDownIcon, PauseCircleIcon,
    ArrowDownOnSquareIcon, MagnifyingGlassIcon, ChevronRightIcon, CheckIcon, XMarkIcon
} from "@heroicons/react/20/solid"

import { motion, AnimatePresence } from "framer-motion"
import { LangugeContext } from "./LangugeContext"
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime"
import "dayjs/locale/zh-cn"
import "./main.css"
import { Routes, Route, useParams, useNavigate } from 'react-router-dom';
import { language_ch, language_en } from "./language"

import deviceDataDc02 from "./jsonPath/cameraDeviceDc02"
import cameraLensDc02 from "./jsonPath/cameraLensDc02"
import cameraBluetoothDc02 from "./jsonPath/cameraBluetoothDc02"
import deviceDataDc02En from "./jsonPath/cameraDeviceDc02En"
import cameraLensDc02En from "./jsonPath/cameraLensDc02En"
import cameraBluetoothDc02En from "./jsonPath/cameraBluetoothDc02En"

import deviceDataDc03 from "./jsonPath/cameraDeviceDc03"
import cameraLensDc03 from "./jsonPath/cameraLensDc03"
import cameraBluetoothDc03 from "./jsonPath/cameraBluetoothDc03"
import deviceDataDc03En from "./jsonPath/cameraDeviceDc03En"
import cameraLensDc03En from "./jsonPath/cameraLensDc03En"
import cameraBluetoothDc03En from "./jsonPath/cameraBluetoothDc03En"

import deviceDataScorpMini from "./jsonPath/cameraDeviceScorpMini"
import cameraLensScorpMini from "./jsonPath/cameraLensScorpMini"
import cameraBluetoothScorpMini from "./jsonPath/cameraBluetoothScorpMini"
import deviceDataScorpMiniEn from "./jsonPath/cameraDeviceScorpMiniEn"
import cameraLensScorpMiniEn from "./jsonPath/cameraLensScorpMiniEn"
import cameraBluetoothScorpMiniEn from "./jsonPath/cameraBluetoothScorpMiniEn"

import deviceDataScorp from "./jsonPath/cameraDeviceScorp"
import cameraLensScorp from "./jsonPath/cameraLensScorp"
import deviceDataScorpEn from "./jsonPath/cameraDeviceScorpEn"
import cameraLensScorpEn from "./jsonPath/cameraLensScorpEn"

import deviceDataScorpC from "./jsonPath/cameraDeviceScorpC"
import cameraLensScorpC from "./jsonPath/cameraLensScorpC"
import deviceDataScorpCEn from "./jsonPath/cameraDeviceScorpCEn"
import cameraLensScorpCEn from "./jsonPath/cameraLensScorpCEn"

import deviceDataScorpPro from "./jsonPath/cameraDeviceScorpPro"
import cameraLensScorpPro from "./jsonPath/cameraLensScorpPro"
import deviceDataScorpProEn from "./jsonPath/cameraDeviceScorpProEn"
import cameraLensScorpProEn from "./jsonPath/cameraLensScorpProEn"

//deviceBloothData = 相机蓝牙控制列表
var deviceBloothData = []
//deviceLenData = 镜头兼容列表 
var deviceLenData = []
//deviceData = 相机线控可控列表
var deviceData = []

dayjs.extend(relativeTime)
dayjs.locale("zh-cn")

export default function DevicesScreen(props) {

    let { language } = useParams()
    if (!language) {
        language = "ch"
    }
    var languagePackage = language === "ch" ? language_ch : language_en

    const navigate = useNavigate();
    const [showSheet, setShowSheet] = useState(false)
    const [pushSheet, setPushSheet] = useState(false)
    const [showSearch, setShowSearch] = useState(false)
    
    const [showSearchNoResult, setShowSearchNoResult] = useState(false)

    // cameraCompatibilityCardType: contrlLine, lens, bluetooth
    const [cameraCompatibilityCardType, setCameraCompatibilityCardType] = useState("contrlLine")

    const searchRef = useRef()
    const [searchkeyWord, setSearchkeyWord] = useState(null)
    const [searchResult, setSearchResult] = useState([])

    // sheetType: brand, camera, Lens
    const [sheetType, setSheetType] = useState("brand")

    const [cameraBrands, setCamerabrands] = useState([])
    const [selectBrand, setSelectBrand] = useState(null)

    const [cameraNames, setCameraNames] = useState([])
    const [selectCamera, setSelectCamera] = useState(null)

     //控制线信息为数组，因为有一些相机拥有两种控制线
    const [showCameraCompatibilityCard, setShowCameraCompatibilityCard] = useState(false)
    const [selectCameraControlLineInfo, setSelectCameraControlLineInfo] = useState([])
     //蓝牙同控制线信息 一致
    const [selectBloothInfo, setSelectBloothInfo] = useState([])

    const [cameraLens, setCameraLens] = useState([])
    const [selectLens, setSelectlens] = useState(null)
    const [selectLensInfo, setSelectLensInfo] = useState(null)

    let { device } = useParams()

    if (!device) {
        device = "SCORP"
    }

    //区分各产品使用的 data模型
    if (device ===  "SCORP") {
        deviceLenData = language === "ch" ? cameraLensScorp : cameraLensScorpEn
        deviceData = language === "ch" ? deviceDataScorp : deviceDataScorpEn
        deviceBloothData = []
    } if (device === "SCORP_PRO") {
        deviceLenData = language === "ch" ? cameraLensScorpPro : cameraLensScorpProEn
        deviceData = language === "ch" ? deviceDataScorpPro : deviceDataScorpProEn
        deviceBloothData = []
    } else if (device ===  "SCORP_C") {
        deviceLenData = language === "ch" ? cameraLensScorpC : cameraLensScorpCEn
        deviceData = language === "ch" ? deviceDataScorpC : deviceDataScorpCEn
        deviceBloothData = []
    } else if (device ===  "SCORP_Mini") {
        deviceLenData = language === "ch" ? cameraLensScorpMini : cameraLensScorpMiniEn
        deviceData = language === "ch" ? deviceDataScorpMini : deviceDataScorpMiniEn
        deviceBloothData = language === "ch" ? cameraBluetoothScorpMini : cameraBluetoothScorpMiniEn
    } else if (device ===  "SCORP2") {
        deviceLenData = language === "ch" ? cameraLensDc03 : cameraLensDc03En
        deviceData = language === "ch" ? deviceDataDc03 : deviceDataDc03En
        deviceBloothData = language === "ch" ? cameraBluetoothDc03 : cameraBluetoothDc03En
    } else if (device ===  "SCORP_Mini2") {
        deviceLenData = language === "ch" ? cameraLensDc02 : cameraLensDc02En
        deviceData = language === "ch" ? deviceDataDc02 : deviceDataDc02En
        deviceBloothData = language === "ch" ? cameraBluetoothDc02 : cameraBluetoothDc02En
    }

    //从 相机线控可控列表(deviceData) 和 蓝牙控制列表(deviceBloothData) --获取--相机品牌列表(cameraBrands)
    useEffect(() => {
        //线控 支持的相机 品牌
        let cameraBrandsArr = deviceData.map(item => item.brand)
        //蓝牙 支持的相机 品牌
        let cameraBrandsBloothArr = deviceBloothData.map(item => item.brand)
        //合并线控列表 与 蓝牙控列表
        const mergeArray =  Array.from(new Set([...cameraBrandsArr, ...cameraBrandsBloothArr]));
        setCamerabrands(mergeArray)
        //首次加载默认相机品牌
        // setSelectBrand( cameraBrands[0])
    }, [])

    //从 相机线控可控列表(deviceData) + 蓝牙控制列表(deviceBloothData) + 选中的相机品牌--获取--该品牌相机型号列表(cameraNames)
    useEffect(() => {
        if (!selectBrand) return
        //线控 支持的相机列表
        const filtedDeviceData = deviceData.filter(item => item.brand === selectBrand)
        const cameraArr = filtedDeviceData.map(item => item.camera)
        //蓝牙 支持的相机列表
        const filtedBlueToothData = deviceBloothData.filter(item => item.brand === selectBrand)
        const blueToothArr = filtedBlueToothData.map(item => item.camera)
        //合并线控列表 与 蓝牙控列表
        var cameraNames =  Array.from(new Set([...cameraArr, ...blueToothArr]));
        cameraNames.sort();
        setCameraNames(cameraNames)
        setSelectCamera(cameraNames[0])
    }, [selectBrand])

    //选中的相机品牌 + 选中相机型号 过滤数据
    useEffect(() => {
        //未选中相机型号 则退出
        if (!selectCamera) {
            setShowCameraCompatibilityCard(false)
            return
        }
        //未选中相机品牌 则退出
        if (!selectBrand) {
            throw new Error("内部错误,请检查")
        }

        //从 蓝牙控制列表(deviceBloothData) 过滤出--选中相机品牌、选中相机型号--的数据 (selectedBloothArr)
        const selectedBloothArr =  deviceBloothData.filter(item => item.brand === selectBrand && item.camera === selectCamera)
        setSelectBloothInfo(selectedBloothArr)
        //从 相机线控可控列表(deviceData) 过滤出--选中相机品牌、选中相机型号--的数据 (selectedControlLineInfo)
        const selectedControlLineInfo = deviceData.filter(item => item.brand === selectBrand && item.camera === selectCamera)
        setSelectCameraControlLineInfo(selectedControlLineInfo)
        //符合任意一个都行
        if (selectedBloothArr.length > 0 || selectedControlLineInfo.length > 0) {
            setShowCameraCompatibilityCard(true)
        }

         //从 镜头兼容列表(deviceLenData) 过滤出--选中相机品牌、选中相机型号--的数据  并去除重复
        const selectedControlCameraLensArr =  deviceLenData.filter(item => item.brand === selectBrand && item.camera === selectCamera)
        const includesCameraLensArr = selectedControlCameraLensArr.filter( (ele, ind) => ind === selectedControlCameraLensArr.findIndex( elem => elem.cameraLen === ele.cameraLen))
        setCameraLens(includesCameraLensArr)
        if (includesCameraLensArr.length > 0) {
            ///默认加载第一项镜头编号
            setSelectlens(includesCameraLensArr[0].cameraLen)
        } else {
            //没有镜头编号 的处理
            setSelectlens(null)
        }

        if (selectedControlLineInfo.length > 0 && selectedBloothArr.length == 0) {
            //有线控就 展示线控 否则展示 蓝牙
            setCameraCompatibilityCardType("contrlLine")
        } 
        if (selectedBloothArr.length > 0 && selectedControlLineInfo.length == 0 ){
            setCameraCompatibilityCardType("bluetooth")
        }
    }, [selectCamera])

    //选中的相机品牌 + 选中相机型号 + 选中镜头编号 过滤数据
    useEffect(() => {
        //未选中镜头编号 则退出
        if (!selectLens) {
            return
        }
        //未选中相机型号 则退出
        if (!selectCamera) {
            return
        }

        //过滤 镜头兼容列表符合条件的数据
        const selectLensArr = deviceLenData.filter(item => item.brand === selectBrand && item.camera === selectCamera && item.cameraLen === selectLens )    
        if (selectLensArr.length > 0) {
            console.log(selectLensArr[0])
            setSelectLensInfo(selectLensArr[0])
        } else {
            setSelectLensInfo(null)
        }
    }, [selectLens])

    //搜索栏
    useEffect(() => {
        if (!searchkeyWord) {
            return
        }

        //合并线控和蓝牙控的数据
        var likeDeviceData = deviceData.filter(item => item.brand.toLowerCase().includes(searchkeyWord.toLowerCase()) || item.camera.toLowerCase().includes(searchkeyWord.toLowerCase()))
        var likeBloothData = deviceBloothData.filter(item => item.brand.toLowerCase().includes(searchkeyWord.toLowerCase()) || item.camera.toLowerCase().includes(searchkeyWord.toLowerCase()))
        var likeData =  Array.from(new Set([...likeDeviceData, ...likeBloothData]))
        if (likeData.length > 100) {
            likeData = likeData.slice(0, 100)
        }
        setSearchResult(likeData)
    }, [searchkeyWord])
    
    useEffect(() => {
        if(searchResult.length > 0 ){
        setShowSearchNoResult(false)
        }
    },[searchResult])

    const [containerMaxHeight, setContainerMaxHeight] = useState(null)

    useEffect(() => {
        setContainerMaxHeight(window.innerHeight)
    }, [])

    return (
        <LangugeContext.Provider value={{ language, languagePackage }} >
            <div
                style={containerMaxHeight ? { height: containerMaxHeight } : null}
                class="w-full h-full overflow-auto"
            >
                <AnimatePresence>
                    <div
                        style={{ backgroundColor: "#EFF0F4" }}
                        class=" container w-full pb-5 flex flex-col justify-start items-center">
                        <form
                            action="."
                            class="w-full px-5 flex flex-row justify-between " 
                            style={{"margin-top": "20px" }}>

                            <input type="text" className="hidden" />

                            <input
                                ref={searchRef}
                                type="search"
                                onFocus={() => {
                                    if(!showSearch){
                                        setShowSearch(true)
                                        setShowSearchNoResult(false)
                                    }
                                }}
                                onBlur={() => {
                                    setTimeout(() => {
                                        //这里需要加一个延时，让文档流延迟移除search card
                                        //不然 searchcard上的列表项目点击事件不会被触发
                                        setShowSearch(false)
                                    }, 60)
                                    // setShowSearch(false)
                                }}
                                onKeyDown={(e) => {
                                    if (e.keyCode == 13) {
                                        setShowSearch(false)
                                        setShowSearchNoResult((searchResult.length == 0 ? true : false))
                                        searchRef.current.blur()
                                    }else if(e.key === 'Enter'){
                                        setShowSearch(false)
                                        setShowSearchNoResult((searchResult.length == 0 ? true : false))
                                        searchRef.current.blur()
                                    }
                                }}
                                placeholder={languagePackage.Deviceinfo.Search_Camera}
                                value={searchkeyWord}
                                onChange={(e) => {
                                    setSearchkeyWord(e.target.value)
                                }}
                                className="input input-bordered input-md w-full  rounded-full shrink-0 border-none focus:outline-none" />

                            {!searchkeyWord &&
                                <label className='btn btn-ghost btn-square absolute right-6'>
                                    <MagnifyingGlassIcon class="w-5 h-5 text-zinc-500"
                                    />
                                </label>
                            }
                        </form>

                        {showSearch &&
                            <motion.div
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                exit={{ opacity: 0 }}
                                style={{ width: "calc(100vw - 2.5rem)" }}
                                className='card p-3 bg-base-100  shrink-0 w-full mx-5 mt-3 min-h-48 max-h-full h-48 overflow-y-scroll no-scrollbar'>


                                {searchResult.length > 0 &&
                                    searchResult.map((item, index) => {
                                        return <SearchResultItem
                                            key={`SearchResultItem_${index}`}
                                            item={item}
                                            setSelectBrand={setSelectBrand}
                                            setSelectCamera={setSelectCamera}
                                            setShowSheet={setShowSheet}
                                        />
                                    })
                                }
                                {searchResult.length == 0 &&

                                    <div className='w-full h-full flex flex-col justify-center items-center'>
                                        <MagnifyingGlassIcon class=" block w-24 h-24  text-gray-300" />
                                        <label className='text-sm font-bold'>{languagePackage.Deviceinfo.No_Search_Result}</label>
                                        <label className='text-sm text-blue-500'
                                            onClick={e => { navigate(`/Feekback/${device}/${language}`) }}
                                        >{languagePackage.Deviceinfo.No_Search_Result_Sub}</label>
                                    </div>
                                }
                            </motion.div>
                        }
                        {
                            showSearchNoResult &&
                            <motion.div
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                exit={{ opacity: 0 }}
                                style={{ width: "calc(100vw - 2.5rem)" }}
                                className='card p-3 bg-base-100  shrink-0 w-full mx-5 mt-3 min-h-48 max-h-full h-48 overflow-y-scroll no-scrollbar'>
                                    <div className='w-full h-full flex flex-col justify-center items-center'>
                                        <div className="w-full flex flex-row justify-end"  >
                                            <label className="btn btn-sm btn-circle"
                                                onClick={e=>{ setShowSearchNoResult(false) }}
                                            >
                                                <XMarkIcon className="w-5 h-5" />
                                                </label>
                                                </div>
                                        <MagnifyingGlassIcon class=" block w-24 h-24  text-gray-300" />
                                        <label className='text-sm font-bold'>{languagePackage.Deviceinfo.No_Search_Result}</label>
                                        <label className='text-sm text-blue-500'
                                            onClick={e => { navigate(`/Feekback/${device}/${language}`) }}
                                        >{languagePackage.Deviceinfo.No_Search_Result_Sub}</label>
                                    </div>
                                
                            </motion.div>
                        }

                        <div
                            style={{ width: "calc(100vw - 2.5rem)" }}
                            className="card mt-3 bg-base-100">
                            <div className="card-body">
                                <div className='flex  min-w-full flex-row justify-between items-center'>
                                    <label className='text-sm'>{languagePackage.Deviceinfo.Camera_brand}</label>
                                    <div
                                        onClick={() => {
                                            setSheetType("brand")
                                            setShowSheet(true)
                                            setPushSheet(true)
                                        }}
                                        class=" text-zinc-500 flex flex-row justify-center items-center" >
                                        <label className='text-sm' >{selectBrand ? selectBrand : languagePackage.Deviceinfo.Select_Your__Camera_Brand}</label>
                                        <ChevronRightIcon className='w-5 h-5' />
                                    </div>
                                </div>

                                <DividingLine />
                                <div className='flex  min-w-full flex-row justify-between items-center'>
                                    <label className='text-sm'>{languagePackage.Deviceinfo.Camera_model}</label>
                                    <div
                                        onClick={() => {
                                            setSheetType("camera")
                                            setShowSheet(true)
                                            setPushSheet(true)
                                        }}
                                        class=" text-zinc-500 flex flex-row justify-center items-center" >
                                        <label className='text-sm font-normal' >{selectCamera ? selectCamera : languagePackage.Deviceinfo.Select_Your_Camera_model}</label>
                                        <ChevronRightIcon className='w-5 h-5' />
                                    </div>
                                </div>
                                <DividingLine />
                                <div className='flex  min-w-full flex-row justify-between items-center'>
                                    <label className='text-sm' >{languagePackage.Deviceinfo.Lens}</label>
                                    <div
                                        onClick={() => {
                                            setSheetType("lens")
                                            setShowSheet(true)
                                            setPushSheet(true)
                                        }}
                                        class=" text-zinc-500 flex flex-row justify-center items-center" >
                                        <label className='text-sm max-w-xs text-ellipsis' >{selectLens ? selectLens : languagePackage.Deviceinfo.Select_Your_Camera_Lens}</label>
                                        <ChevronRightIcon className='w-5 h-5' />
                                    </div>
                                </div>
                            </div>
                        </div>

                        {
                            showCameraCompatibilityCard &&
                            <div
                                style={{ width: "calc(100vw - 2.5rem)" }}
                                className="card mt-3 bg-base-100">
                                <div className="card-body">
                                    <label className='text-sm'>{selectCamera ?
                                        `${selectBrand} ${selectCamera} ${languagePackage.Deviceinfo.Device_Info_Title}` :
                                        languagePackage.Deviceinfo.Device_Info_Title}</label>
                                    <div className="tabs mb-2 flex-nowrap">
                                        {/* contrlLine, lens, bluetooth */}
                                        <a
                                            className={cameraCompatibilityCardType == "contrlLine" ? "tab tab-bordered tab-active whitespace-nowrap" : "tab tab-bordered whitespace-nowrap"}
                                            onClick={() => {
                                                setCameraCompatibilityCardType("contrlLine")
                                            }}
                                        >{languagePackage.Deviceinfo.Control_cable}</a>
                                        <a className={cameraCompatibilityCardType === "lens" ? "tab tab-bordered tab-active" : "tab tab-bordered"}
                                            onClick={() => {
                                                if (!selectLens) {
                                                    return
                                                }
                                                setCameraCompatibilityCardType("lens")
                                            }}
                                        >{languagePackage.Deviceinfo.Balance}</a>
                                        <a className={cameraCompatibilityCardType === "bluetooth" ? "tab tab-bordered tab-active" : "tab tab-bordered"}
                                            onClick={() => {
                                                if (!selectBrand) {
                                                    return
                                                }
                                                if (!selectCamera) {
                                                    return
                                                }
                                                setCameraCompatibilityCardType("bluetooth")
                                            }}
                                        >{languagePackage.Deviceinfo.Bluetooth}</a>
                                    </div>

                                    {
                                        cameraCompatibilityCardType === "contrlLine" &&
                                        <ControlLineSheet
                                            selectCameraControlLineInfo={selectCameraControlLineInfo}
                                        />
                                    }
                                    {
                                        cameraCompatibilityCardType === "lens" &&
                                        <LensSheet
                                            selectLens={selectLens}
                                            selectLensInfo={selectLensInfo}
                                        />
                                    }
                                    {
                                        cameraCompatibilityCardType === "bluetooth" &&
                                        <BluetoothSheet 
                                            device={device}
                                            selectBloothInfo={selectBloothInfo}
                                        />
                                    }
                                </div>
                            </div>
                        }
                    </div>
                </AnimatePresence>

                {/* 相机品牌型号选择 pop sheet  */}
                <div
                    style={showSheet ? { display: "block" } : { display: "none" }}
                    className='w-full h-full fixed z-50 top-0 left-0'
                    onClick={() => {
                        setPushSheet(false)
                        setTimeout(() => setShowSheet(false), 250)
                    }}
                >
                    <motion.div
                        animate={pushSheet ? { bottom: 0 } : { bottom: -320 }}
                        className='bg-base-100 w-full h-[320px] fixed bottom-0  rounded-t-2xl p-5 shadow-[0_35px_60px_15px_rgba(0,0,0,0.3)]'>
                        <div className='w-full text-center  font-bold pt-0'>
                            {sheetType === "brand" ?
                                languagePackage.Deviceinfo.Camera_brand :
                                sheetType === "camera" ?
                                    languagePackage.Deviceinfo.Camera_model
                                    :
                                    languagePackage.Deviceinfo.Lens
                            }
                        </div>
                        <div
                            class="w-full h-full sheet-content overflow-y-scroll overflow-x-hidden pb-5" 
                        >
                            {sheetType === "brand" && <CameraBrandNamesSheet
                                cameraBrands={cameraBrands}
                                setShowSheet={setShowSheet}
                                setPushSheet={setPushSheet}
                                setSelectBrand={setSelectBrand}
                            />}
                            {
                                sheetType === "camera" &&
                                <CameraNamesSheet
                                    cameraNames={cameraNames}
                                    setShowSheet={setShowSheet}
                                    setPushSheet={setPushSheet}
                                    setSelectCamera={setSelectCamera}
                                />
                            }
                            {
                                sheetType === "lens" &&
                                <CameraLensSheet
                                    cameraLens={cameraLens}
                                    setSelectlens={setSelectlens}
                                    setShowSheet={setShowSheet}
                                    setPushSheet={setPushSheet}
                                />
                            }
                        </div>
                    </motion.div>
                </div>


            </div>
        </LangugeContext.Provider>
    )

}

function FakeItem() {

    const fakeCameraNames = ["飞宇Scorp", "飞宇Scorp-C", "飞宇Scorp Mini", "飞宇Scorp Pro", "飞宇Vimble 4", "飞宇Scorp Mini2", "飞宇Scorp Mini3"]
    const [cameraName, setCameraName] = useState("")
    useEffect(() => {
        const randomNumber = Math.floor(Math.random() * 7);
        setCameraName(fakeCameraNames[randomNumber])
    })

    return <div className='flex h-8 px-3 my-2 min-w-full flex-row  justify-start items-center'>

        <MagnifyingGlassIcon className='w-5 h-5 text-zinc-400' />
        <label className='text-sm ml-4'>{cameraName}</label>
    </div>
}

function DividingLine() {
    return <div className="h-[1px] bg-gray-200 my-2"></div>
}


// 选择相机品牌
function CameraBrandNamesSheet(props) {
    const { cameraBrands, setShowSheet, setPushSheet, setSelectBrand } = props
    const { language, languagePackage } = useContext(LangugeContext)

    return <div>
        {cameraBrands.length == 0 &&
            <div class="w-full h-36 flex justify-center items-center" >
                <label class="block text-gray-500">{languagePackage.Deviceinfo.No_Data_Recored}</label>
            </div>
        }
        {
            cameraBrands.map((item, index) => {
                return <div
                    key={`cameraBrandName_${index}`}
                    className='flex h-6 my-5 mx-2  min-w-full flex-row justify-between items-center'
                    onClick={() => {
                        setShowSheet(true)
                        setPushSheet(true)
                        setSelectBrand(item)
                    }}
                >
                    <label className='text-md'>{item}</label>
                    <div
                        class=" text-zinc-500 flex flex-row justify-center items-center" >
                        {/* <label className='text-sm font-normal' >选择</label> */}
                        <ChevronRightIcon className='w-8 h-8' />
                    </div>
                </div>
            })
        }

    </div>
}

// 选择相机型号
function CameraNamesSheet(props) {
    const { cameraNames, setShowSheet, setPushSheet, setSelectCamera } = props
    const { language, languagePackage } = useContext(LangugeContext)
    return <div>
        {cameraNames.length == 0 &&
            <div class="w-full h-36 flex justify-center items-center" >
                <label class="block text-gray-500">{languagePackage.Deviceinfo.No_Data_Recored}</label>
            </div>
        }
        {
            cameraNames.map((item, index) => {
                return <div
                    key={`cameraBrandName_${index}`}
                    className='flex h-6 my-3 mx-2  min-w-full flex-row justify-between items-center'
                    onClick={() => {
                        setShowSheet(true)
                        setPushSheet(true)
                        setSelectCamera(item)
                    }}
                >
                    <label className='text-md'>{item}</label>
                    <div
                        class=" text-zinc-500 flex flex-row justify-center items-center" >
                        <ChevronRightIcon className='w-8 h-8' />
                    </div>
                </div>
            })
        }

    </div>
}

//选择相机镜头
function CameraLensSheet(props) {
    const { cameraLens, setSelectlens, setShowSheet, setPushSheet } = props
    const { language, languagePackage } = useContext(LangugeContext)

    return <div>

        {cameraLens.length == 0 &&
            <div class="w-full h-36 flex justify-center items-center" >
                <label class="block text-gray-500">{languagePackage.Deviceinfo.No_Data_Recored}</label>
            </div>
        }
        {
            cameraLens.map((item, index) => {
                return <div
                    key={`cameraLensName_${index}`}
                    className='flex h-6 my-3 mx-2  min-w-full flex-row justify-between items-center'
                    onClick={() => {
                        setShowSheet(true)
                        setPushSheet(true)
                        setSelectlens(item.cameraLen)
                    }}
                >
                    <label className='text-md'>{item.cameraLen}</label>
                    <div
                        class=" text-zinc-500 flex flex-row justify-center items-center" >
                        <ChevronRightIcon className='w-8 h-8' />
                    </div>
                </div>
            })
        }

    </div>
}

//兼容性 sheet 控制线
function ControlLineSheet(props) {
    //控制线信息为数组，因为有一些相机拥有两种控制线
    const { selectCameraControlLineInfo } = props
    const { language, languagePackage } = useContext(LangugeContext)

    function line(items) {
        return (
            <>
                {items.map((item, index) => {
                    const { title, value } = item
                    return (
                        <Fragment key={`${title}+${index}`}  >
                            <div class="sheet-line w-full  flex flex-wrap justify-between items-center">
                                <div class="flex-1 text-left">
                                    <label class="text-sm leading-5 text-left">
                                        {title}
                                    </label>
                                </div>
                                <div class="flex-1 h-5 text-center flex justify-center items-center">

                                    {value === "√" ?
                                        <CheckIcon class="w-5 h-5 text-green-500" />
                                        : value !== "×" ?
                                            <label className='text-xs'>{value}</label>
                                            :
                                            <XMarkIcon class="w-5 h-5 text-red-600" />
                                    }
                                </div>
                            </div>
                            <div className="h-[1px] bg-gray-200 my-0"></div>
                        </Fragment>
                    )
                })}
            </>
        )
    }

    if (selectCameraControlLineInfo.length > 0) {
        return (
            <>
                <div class="sheet-title w-full h-8  flex flex-wrap justify-between items-center">
                    <div class="flex-1 h-8 bg-blue-300 text-center"><label class="text-sm h-8 leading-8 font-bold text-center">{languagePackage.Deviceinfo.Control_features_cable}</label></div>
                    <div class="w-[1px]" ></div>
                    <div class="flex-1 h-8 bg-blue-300 text-center"><label class="text-sm h-8 leading-8 font-bold text-center">{languagePackage.Deviceinfo.Controllability}</label></div>
                </div>
                {
                    selectCameraControlLineInfo.map((item, index) => {
    
                        const { brand, camera, controlLine, photo, video,
                            lineTimeMonitor, shutter, aperture, sensor,
                            halfShutter, focus, zoom, cameraFirmware,
                            gimbalFirmware, note } = item
                        const items = [
                            { title: languagePackage.Deviceinfo.Capture_photo, value: photo },
                            { title: languagePackage.Deviceinfo.Record_video, value: video },
                            { title: languagePackage.Deviceinfo.Playback, value: lineTimeMonitor },
                            { title: languagePackage.Deviceinfo.Shutter_speed, value: shutter },
                            { title: languagePackage.Deviceinfo.Aperture_Adjustment, value: aperture },
                            { title: languagePackage.Deviceinfo.ISO_Adjustment, value: sensor },
                            { title: languagePackage.Deviceinfo.Halfway_Press_To_Focus, value: halfShutter },
                            { title: languagePackage.Deviceinfo.Electronic_Follow_Focus, value: focus },
                            { title: languagePackage.Deviceinfo.Electronic_Zoom, value: zoom },
                            { title: languagePackage.Deviceinfo.Camera_Firmware_Version, value: cameraFirmware },
                            { title: languagePackage.Deviceinfo.Gimbal_Firmware_Version, value: gimbalFirmware },
                        ]
                        return <Fragment key={`${camera}+${index}`}>
                            <div class="sheet-line w-full   flex flex-wrap justify-start items-center">
                                <div class="flex-1  text-left">
                                    <label class="text-sm  leading-5 text-center font-bold">{controlLine}</label>
                                </div>
                            </div>
                            <div className="h-[1px] bg-gray-200 my-0"></div>
                            {
                                line(items)
                            }
                            {
                                !!item.note &&
                                <>
                                    <p className='text-xs text-gray-500 mt-3'>{languagePackage.Deviceinfo.Note}</p>
                                    <p
                                        className=' text-xs text-gray-500 whitespace-pre-line'>
                                        {item.note}
                                    </p>
                                </>
                            }
                        </Fragment>
                    })
                }
            </>
        )
    } else {
        return (<div class="w-full h-36 flex justify-center items-center" >
                            <label class="block">{languagePackage.Deviceinfo.No_Data_Recored}</label>
                    </div>)
    }
}

//搜索框 搜索item
function SearchResultItem(props) {

    const { item, setSelectBrand, setSelectCamera, setShowSheet } = props


    return <div
        onClick={(e) => {
            console.log(e)
            setSelectBrand(item.brand)
            setTimeout(() => {
                setSelectCamera(item.camera)
                // setShowSheet(true)
            }, 200)
        }}
        className='flex h-8 px-3 my-2 min-w-full flex-row  justify-start items-center z-50'>
        <MagnifyingGlassIcon className='w-5 h-5 text-zinc-400' />
        <label

            className='text-sm ml-4'>{`${item.brand} ${item.camera}`}</label>
    </div>
}
//兼容性 sheet 镜头调平
function LensSheet(props) {
    //控制线信息为数组，因为有一些相机拥有两种控制线
    const { selectLensInfo, selectLens } = props
    const { language, languagePackage } = useContext(LangugeContext)
    const [items, setItems] = useState([])

    useEffect(() => {
        if (!selectLensInfo) {
            return
        }
        setItems([{ title: languagePackage.Deviceinfo.Short_End_Horizontally, value: selectLensInfo.horizontallyShort },
        { title: languagePackage.Deviceinfo.Long_End_Horizontally, value: selectLensInfo.horizontallyLong },
        { title: languagePackage.Deviceinfo.Short_End_Vertically, value: selectLensInfo.verticalShort },
        { title: languagePackage.Deviceinfo.Long_End_Vertically, value: selectLensInfo.verticalLong }])
    }, [selectLensInfo])

    useEffect(() => {
        if (!selectLens) {
            setItems([])
        }
    }, [selectLens])

    function line(items) {
        return <>
            {items.map((item, index) => {
                const { title, value } = item
                return (
                    <>
                        <div class="sheet-line w-full   flex flex-wrap justify-between items-center">
                            <div class="flex-1  text-left">
                                <label class="text-sm leading-5 text-left">{title}</label></div>
                            <div class="flex-1  text-center flex justify-center items-center">

                                {value === "√" ?
                                    <CheckIcon class="w-5 h-5 text-green-500" />
                                        : value !== "×" ?
                                            <label className='text-xs'>{value}</label>
                                            :
                                            <XMarkIcon class="w-5 h-5 text-red-600" />
                                }
                            </div>
                        </div>
                        <div className="h-[1px] bg-gray-200 my-0"></div>
                    </>

                )
            })}

        </>
    }

    return (
        <>
            <div class="sheet-title w-full h-8  flex flex-wrap justify-between items-center">
                <div class="flex-1 h-8 bg-blue-300 text-center"><label class="text-sm h-8 leading-8 font-bold text-center">{languagePackage.Deviceinfo.Camera_Mounting_Method}</label></div>
                <div class="w-[1px]" ></div>
                <div class="flex-1 h-8 bg-blue-300 text-center"><label class="text-sm h-8 leading-8 font-bold text-center">{languagePackage.Deviceinfo.Balance}</label></div>
            </div>
            {
                selectLens == null &&
                <               div class="w-full h-36 flex justify-center items-center" >
                    <label class="block">{languagePackage.Deviceinfo.Need_Select_Lens}</label>
                </div>
            }
            {
                selectLensInfo == null &&
                <div class="w-full h-36 flex justify-center items-center" >
                    <label class="block">{languagePackage.Deviceinfo.No_Data_Recored}</label>
                </div>
            }
            {!!selectLensInfo &&
                line(items)
            }
            {!!selectLensInfo.installationRemark &&
                <>
                    <p className='text-xs text-gray-500 mt-3'>{languagePackage.Deviceinfo.Note}</p>
                    <p className=' text-xs text-gray-500 whitespace-pre-line'>
                        {selectLensInfo.installationRemark}
                    </p>
                </>
            }
        </>
    )

}
//兼容性 sheet 蓝牙控制
function BluetoothSheet(props) {
    const { device,selectBloothInfo} = props
    const { language, languagePackage } = useContext(LangugeContext)

    function line(items) {
        return (
            <>
                {items.map((item, index) => {
                    const { title, value } = item
                    return (
                        <Fragment key={`${title}+${index}`}  >
                            <div class="sheet-line w-full  flex flex-wrap justify-between items-center">
                                <div class="flex-1 text-left">
                                    <label class="text-sm leading-5 text-left">
                                        {title}
                                    </label>
                                </div>
                                <div class="flex-1 h-5 text-center flex justify-center items-center">

                                    {value === "√" ?
                                        <CheckIcon class="w-5 h-5 text-green-500" />
                                        : value !== "×" ?
                                            <label className='text-xs'>{value}</label>
                                            :
                                            <XMarkIcon class="w-5 h-5 text-red-600" />
                                    }
                                </div>
                            </div>
                            <div className="h-[1px] bg-gray-200 my-0"></div>
                        </Fragment>
                    )
                })}
            </>
        )
    }

    if (selectBloothInfo.length > 0) {
        return (
            <>
                <div class="sheet-title w-full h-8  flex flex-wrap justify-between items-center">
                    <div class="flex-1 h-8 bg-blue-300 text-center"><label class="text-sm h-8 leading-8 font-bold text-center">{languagePackage.Deviceinfo.Control_features_bluetooth}</label></div>
                    <div class="w-[1px]" ></div>
                    <div class="flex-1 h-8 bg-blue-300 text-center"><label class="text-sm h-8 leading-8 font-bold text-center">{languagePackage.Deviceinfo.Controllability}</label></div>
                </div>
                {
                    selectBloothInfo.map((item, index) => {
                        const { brand, camera, controlFunction, photo, video,
                            blueToothTimeMonitor, shutter, aperture, sensor,
                            halfShutter, focus, zoom, cameraFirmware,
                            blueToothFirmware, note } = item
                        var items = [
                            { title: languagePackage.Deviceinfo.Capture_photo, value: photo },
                            { title: languagePackage.Deviceinfo.Record_video, value: video },
                            { title: languagePackage.Deviceinfo.Playback, value: blueToothTimeMonitor },
                            { title: languagePackage.Deviceinfo.Shutter_speed, value: shutter },
                            { title: languagePackage.Deviceinfo.Aperture_Adjustment, value: aperture },
                            { title: languagePackage.Deviceinfo.ISO_Adjustment, value: sensor },
                            { title: languagePackage.Deviceinfo.Halfway_Press_To_Focus, value: halfShutter },
                            { title: languagePackage.Deviceinfo.Electronic_Follow_Focus, value: focus },
                            { title: languagePackage.Deviceinfo.Electronic_Zoom, value: zoom },
                            { title: languagePackage.Deviceinfo.Camera_Firmware_Version, value: cameraFirmware },
                            { title: languagePackage.Deviceinfo.BlueTooth_Firmware_Version, value: blueToothFirmware },
                        ]
                        if (device ===  "SCORP_Mini") {
                            items = [
                                { title: languagePackage.Deviceinfo.Capture_photo, value: photo },
                                { title: languagePackage.Deviceinfo.Record_video, value: video },
                                { title: languagePackage.Deviceinfo.Playback, value: blueToothTimeMonitor },
                                { title: languagePackage.Deviceinfo.Shutter_speed, value: shutter },
                                { title: languagePackage.Deviceinfo.Aperture_Adjustment, value: aperture },
                                { title: languagePackage.Deviceinfo.ISO_Adjustment, value: sensor },
                                { title: languagePackage.Deviceinfo.Halfway_Press_To_Focus, value: halfShutter },
                                { title: languagePackage.Deviceinfo.Electronic_Follow_Focus, value: focus },
                                { title: languagePackage.Deviceinfo.Electronic_Zoom, value: zoom },
                                { title: languagePackage.Deviceinfo.Camera_Firmware_Version, value: cameraFirmware },
                                { title: languagePackage.Deviceinfo.Gimbal_Firmware_Version, value: blueToothFirmware },
                            ]
                        }
                        return <Fragment key={`${camera}+${camera}+${index}`}>
                            <div class="sheet-line w-full   flex flex-wrap justify-start items-center">
                                <div class="flex-1  text-left">
                                    <label class="text-sm  leading-5 text-center font-bold">{controlFunction}</label>
                                </div>
                            </div>
                            <div className="h-[1px] bg-gray-200 my-0"></div>
                            {
                                line(items)
                            }
                            {
                                !!item.note &&
                                <>
                                    <p className='text-xs text-gray-500 mt-3'>{languagePackage.Deviceinfo.Note}</p>
                                    <p
                                        className=' text-xs text-gray-500 whitespace-pre-line'>
                                        {item.note}
                                    </p>
                                </>
                            }
                        </Fragment>
                    })
                }
            </>
        )
    } else {
        return (<div class="w-full h-36 flex justify-center items-center" >
                        <label class="block">{languagePackage.Deviceinfo.No_Data_Recored}</label>
                    </div>)
    }
} 

// yt-dlp -f 'bv[ext=mp4]+ba[ext=m4a]' –embed-metadata –merge-output-format mp4 https://youtu.be/KgyKiBkgbCM